export function readFromStorage(storage, key) {
  const item = storage.getItem(key)
  if (item === null) {
    return null
  }

  try {
    return JSON.parse(item)
  } catch (error) {
    console.error(`Failed to parse localStorage key "${key}":`, error)
    // Return the raw string as fallback instead of removing it
    return item
  }
}

export function saveToStorage(storage, key, value) {
  try {
    // Always JSON.stringify to ensure consistent serialization
    storage.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.error(`Failed to save to localStorage key "${key}":`, error)
  }
}

export function removeFromStorage(storage, key) {
  try {
    storage.removeItem(key)
  } catch (error) {
    console.error(error)
  }
}
